import React, { MouseEvent } from 'react';

import styles from './styles.module.css';

import { ReactComponent as IconArrow } from '../assets/icon-arrow-down.svg';

interface AccordionItemProps {
  data: {
    title: string;
    body: string;
  };
  active: boolean;
  onClickHandler: (e: MouseEvent) => void;
}

const AccordionItem = (props: AccordionItemProps) => {
  return (
    <div className={`${styles['accordion-item']}`}>
      <div className={`${styles['title']} ${props.active ? styles['active'] : ''}`} onClick={props.onClickHandler}>
        <p>{props.data.title}</p>
        <div className={styles['icon']}><IconArrow/></div>
        
      </div>
      { props.active && 
        <div className={styles['body']}>
          {props.data.body}
        </div>
      }
    </div>
  );
}

export default AccordionItem;